export default {
  name: 'pdf',
  data () {
    return {
      pdf: null,
      apiUrl: null
    }
  },
  mounted () {
    this.apiUrl = (process.env.VUE_APP_API_URL ? process.env.VUE_APP_API_URL : '').replace('{BASEURL}', window.location.host);
    if (this.$route.params.filename) {
      this.pdf = this.$route.params.filename;
    }
  }
}
